
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "./AuthContext";


const ProtectedRoute = ({ children }) => {
  const { isLoggedIn, authLoading } = useContext(AuthContext);

  if (authLoading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f8f9fa",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
      </div>
    );
  }


  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;